import React from 'react';

const SAVE_LABELS = {
  saving: 'Saving…',
  dirty: 'Unsaved changes',
  saved: 'Saved',
  error: 'Save failed — retrying on next edit',
};

const DocFullPageToolbar = ({ saveState }) => (
  <div className="doc-toolbar doc-fullpage__toolbar">
    <span className="doc-editor-toolbar-slot" />
    <div className="doc-fullpage__toolbar-end">
      <span className={`doc-fullpage__save-state ${saveState === 'error' ? 'is-error' : ''}`}>
        {SAVE_LABELS[saveState] || ''}
      </span>
    </div>
  </div>
);

export default DocFullPageToolbar;
